export default "https://cdn.questicon.mathletics.com/assets/images/Fluency-L-ed7a5f81156616686433110b57bb50da.png";